import React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";

function CreateProfileForm() {
  return (
    <>
      <div>
        <div>
          <Button variant="primary" className="btn-sm"><Trans defaults="Create Profile Manually" i18nKey="createProfileManually" /></Button>
        </div>
      </div>
    </>
  );
}

export default CreateProfileForm;
